<template>
  <div class="dtxx">
    <div class="btns__container">
      <!-- <el-button size="mini" type="primary" class="plr28" @click="handleInput"
        >导入</el-button
      > -->
      <el-button
        size="mini"
        type="primary"
        class="plr28"
        @click="handleAdd"
        plain
        >添加</el-button
      >
      <el-button
        size="mini"
        type="primary"
        class="plr28"
        @click="handleDelete"
        plain
        >删除</el-button
      >
    </div>
    <div class="table__container">
      <el-table
        v-loading="tableLoading"
        :data="list"
        height="400"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          prop="equipmentCode"
          label="项目类型"
          width="100"
        ></el-table-column> -->
        <el-table-column
          show-overflow-tooltip
          prop="liftNumber"
          label="设备代码"
          width="150"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="annualInspectionDate"
          label="年检日期"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="legalPerson"
          label="法人(负责人)"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="legalPersonMobilePhone"
          label="法人(负责人)手机"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="legalPersonPhone"
          label="法人(负责人)电话"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="securityManagement"
          label="安管人员"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="securityManagementMobilePhone"
          label="安管人员手机"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="securityManagementPhone"
          label="安管人员电话"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="nextAnnualInspectionDate"
          label="下检日期"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="innerCode"
          label="单位内编号"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="manufactureCompany"
          label="制造单位"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="maintainCompany"
          label="维保单位"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="equipmentParameters"
          label="设备参数"
          width="100"
        ></el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="liftModel"
          label="型号"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="liftBrand"
          label="品牌"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="liftType"
          label="类型"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="stationNumber"
          label="层站门/跨度"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="nominalLoad"
          label="载重"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="nominalSpeed"
          label="速度"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="equipmentPrice"
          label="设备单价"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="freightPrice"
          label="运费单价"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="installPrice"
          label="安装单价"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="otherPrice01"
          label="其他单价1"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="otherPrice02"
          label="其他单价2"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="otherPrice03"
          label="其他单价3"
          width="100"
        ></el-table-column>

        <el-table-column label=" " prop=" "></el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <div class="btn-divide"></div>

            <el-button
              size="mini"
              type="text"
              @click="handleDeleteLift(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagenation__container">
      <div class="for-fff-bg">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[25, 50, 100, 150, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <add-lift
      v-if="addLiftVisible"
      @cancel="addLiftVisible = false"
      @confirm="handleAddLiftConfirm"
      :projectId="projectId"
    ></add-lift>
    <edit-lift
      v-if="editLiftVisible"
      :editData="liftDetail"
      :projectId="projectId"
      @cancel="editLiftVisible = false"
      @confirm="handleEditLiftConfirm"
    ></edit-lift>
    <import-dialog
      @cancel="showImport = false"
      @uploadFinish="uploadFinish"
      v-if="showImport"
      :importFun="importFun"
      :downFun="downFun"
      :modal="false"
    />
  </div>
</template>

<script>
import {

  getDepartmentTree,
  exportLiftTemplate,
  importLift,
  exportLiftList,
} from "@/api/ElevatorManagement";

import { getLiftPageList, deleteLift } from "@/api/salesManagement/detail";
import { getUnitSimpleList } from "@/api/ProjectManagement";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import ImportDialog from "@/components/ImportDialog/ImportDialog";
import AddLift from "./AddLift";
import EditLift from "./EditLift";
export default {
  name: "ProjectDTXX",
  props: ["projectId"],
  components: {
    AddLift,
    EditLift,
    ImportDialog,
  },
  data() {
    return {
      form: {
        projectId: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addLiftVisible: false,
      editLiftVisible: false,
      checkUnitVisible: false,
      checkQrCode: false,
      liftDetail: {},
      unitList: [],
      projectList: [],
      addressWarn: false,
      showDetailAddress: true,
      addressName: "省市区",
      showStopMaintain: false,
      showStartMaintain: false,
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      departmentIdList: [],
      showImport: false,
      importFun: importLift,
      downFun: exportLiftTemplate,
      showRecord: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form.projectId = this.projectId;

      this.getListData();
    });
  },
  methods: {
    async getDepartmentTree() {
      const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getLiftPageList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteLift(row) {
      const idList = [row.id];
      this.deleteLift(idList);
    },
    handleCheck(row) {
      this.liftDetail = row;
      this.checkQrCode = true;
    },
    handleEdit(row) {
      this.liftDetail = row;
      this.editLiftVisible = true;
    },
    handleEditCopy(row) {
      this.liftDetail = { ...row };
      this.liftDetail.copy = true;
      this.editLiftVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteLift(idList);
    },
    deleteLift(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteLift({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addLiftVisible = true;
    },
    exportLiftList() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      params.liftIdList = this.multipleSelection.map((item) => item.id);
      exportLiftList(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddLiftConfirm() {
      this.addLiftVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditLiftConfirm() {
      this.editLiftVisible = false;
      this.getListData();
    },

    stopMaintainConfirm() {
      this.showStopMaintain = false;
      this.getListData();
    },
    startMaintainConfirm() {
      this.showStartMaintain = false;
      this.getListData();
    },
    changeMaintainType(row) {
      this.liftDetail = { ...row };
      if (row.maintainStatus === 1) {
        this.showStopMaintain = true;
      } else {
        this.showStartMaintain = true;
      }
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      if (val && val.length) {
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.departmentIdList.push(item.data.id);
        });
      }
      this.handleSearchListData();
    },
    uploadFinish() {
      this.showImport = false;
      this.handleSearchListData();
    },
    handleInput() {
      this.showImport = true;
    },
    importRecords() {
      this.showRecord = true;
    },
    handleCommand(val, row) {
      if (val === "fuzhi") {
        this.handleEditCopy(row);
      } else if (val === "tingbao") {
        this.changeMaintainType(row);
      } else if (val === "erweima") {
        this.handleCheck(row);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/dtxx.vue